import { CouponType, OrderMethod, PaymentMethod, RefundReason } from '../../../../../../services/exports/Constants';

export default {
  title: 'Order Information',
  sections: {
    driver_info: 'Driver info',
    order_info: 'Order Information',
    price_info: 'Price Information',
    adjustments: 'Adjustments',
  },
  order_methods: {
    [OrderMethod.Pickup]: 'Pickup',
    [OrderMethod.Delivery]: 'Delivery',
    [OrderMethod.OnSite]: 'Table ordering',
  },
  labels: {
    wolt_support: 'Wolt support phone number: {{phone_number}}',
    wolt_support_text:
      'If you have any questions about the order, the driver or problems, call Wolt. It is important to say that it is a <strong>Wolt Drive</strong> order',
    dummy_order: 'Test order',
    asap: 'ASAP',
    driver_name: 'Driver name',
    driver_phone_number: 'Driver phone',
    pin_code: 'PIN',
    dropoff_pin_code: 'Delivery PIN',
    original: 'Original',
    delivery_fee: 'Delivery fee',
    tip: 'Tip',
    service_fee: 'Online processing',
    payment_method_upcharge_fee: {
      [PaymentMethod.Paypal]: 'PayPal fee',
    },
    promo_applied: {
      default: 'Promo applied',
      [CouponType.Reward]: 'Loyalty points applied',
      [CouponType.Cashback]: 'Loyalty points applied',
      [CouponType.PromoCode]: 'Promo applied',
      [CouponType.GiftCard]: 'Gift card applied',
    },
    tax: 'Taxes',
    total: 'Total',
    online_payment: 'Customer already paid in {{provider}} app',
    cash_payment: 'Payment on site',
    invoice_payment: 'Payment via invoice',
    old_order: 'This order has been successfully fulfilled',
    pickup_time: 'Pickup time',
    pickup_asap: 'The customer has asked for the fastest possible pickup.',
    points_used: 'This order includes a loyalty point reward redeemed by a loyal customer',
    order_note: 'Order note:',
    today: 'today',
  },
  schedule: {
    header: 'Scheduled for {{date}}, {{time}}',
    text: 'We will remind you when it’s time to start preparing the order',
  },
  adjustment_reasons: {
    [RefundReason.RequestedByCustomer]: 'Requested by customer',
    [RefundReason.Reclamation]: 'Reclamation',
    [RefundReason.CommunicationError]: 'Communication error',
    [RefundReason.Other]: 'Other',
    [RefundReason.Dispute]: 'Customer dispute',
    dispute_win: 'Won customer dispute',
    null: '',
  },
  toasts: {
    print_one: 'Printing {{count}} receipt: Order <strong>#{{orderNumber}}</strong>...',
    print_other: 'Printing {{count}} receipts: Order <strong>#{{orderNumber}}</strong>...',
    refund_successful: 'Refund successful: Order <strong>#{{orderNumber}}</strong>...',
  },
  buttons: {
    print: 'Print',
    confirm: 'Confirm',
    reject: 'Reject',
    refund: 'Refund',
  },
};
